import React from "react";
import MailTo from "./MailTo";
import { Container, SectionWrapper, Ptag } from "../../globalStyles";
import {
  FooterWrapper,
  CompanyInfoWrapper,
  CompanyName,
  Address,
  ContactWrapper,
  IconInfoWrapper,
  Icon,
  IconSideText,
  MapWrapper,
  GoogleMap,
  FooterCopyright,
} from "./FooterStyles";

import IconEmailBox from "./svg/IconEmailBox";
import Phone from "./svg/phone";
const Footerapp = () => {
  return (
    <>
      <div id="footer" />
      <SectionWrapper inverse={false}>
        <Container>
          <FooterWrapper>
            <CompanyInfoWrapper>
              <CompanyName>DYNAMIC MANAGEMENT GROUP LIMITED</CompanyName>

              <Address>
                ROOM A 4TH FLOOR, SING TECK FACTORY BUILDING, 44 WONG CHUK HANG
                ROAD, WONG CHUK HANG, HONG KONG
              </Address>

              <ContactWrapper>
                <IconInfoWrapper>
                  <Icon>
                    <Phone />
                  </Icon>
                  <IconSideText>
                    <Ptag white="true">Contact us: +852 2663 3524</Ptag>
                  </IconSideText>
                </IconInfoWrapper>
                <IconInfoWrapper>
                  <Icon>
                    <IconEmailBox />
                  </Icon>

                  <IconSideText>
                    <MailTo
                      label="Email us: info@dynevents.com"
                      mailto="mailto: info@dynevents.com"
                    ></MailTo>
                  </IconSideText>
                </IconInfoWrapper>
              </ContactWrapper>
            </CompanyInfoWrapper>

            <MapWrapper>
              <a
                href={"https://goo.gl/maps/chtxzMcoe8K11uNJ6"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <GoogleMap />
              </a>
            </MapWrapper>
          </FooterWrapper>
          <FooterCopyright>
            © 2002 - {new Date().getUTCFullYear()} DYNAMIC MANAGEMENT GROUP
            LIMITED. ALL RIGHTS RESERVED.
          </FooterCopyright>
        </Container>
      </SectionWrapper>
    </>
  );
};

export default Footerapp;
